import JoinUs from './join-us'
export default [
  {
    path: '/joinUs',
    name: 'join-us',
    component: JoinUs
  }
]



// WEBPACK FOOTER //
// ./src/components/join-us/join-us-router.js